import { render, staticRenderFns } from "./MergeMessageViewer.vue?vue&type=template&id=7131260d&scoped=true"
import script from "./MergeMessageViewer.vue?vue&type=script&lang=js"
export * from "./MergeMessageViewer.vue?vue&type=script&lang=js"
import style0 from "./MergeMessageViewer.vue?vue&type=style&index=0&id=7131260d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7131260d",
  null
  
)

export default component.exports